var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_4394",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 4394",
    transform: "translate(-16308 756)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_18020",
    "data-name": "\\u9577\\u65B9\\u5F62 18020",
    width: 20,
    height: 20,
    transform: "translate(16308 -756)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_3734",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 3734",
    transform: "translate(16311.298 -753.526)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_381",
    "data-name": "\\u30D1\\u30B9 381",
    d: "M88.478-78.66a4.074,4.074,0,0,0,4.068-4.069A4.073,4.073,0,0,0,88.478-86.8a4.074,4.074,0,0,0-4.069,4.068A4.074,4.074,0,0,0,88.478-78.66Zm0-6.9a2.835,2.835,0,0,1,2.831,2.831A2.835,2.835,0,0,1,88.478-79.9a2.835,2.835,0,0,1-2.832-2.832A2.835,2.835,0,0,1,88.478-85.56Z",
    transform: "translate(-81.859 86.797)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_382",
    "data-name": "\\u30D1\\u30B9 382",
    d: "M92.417-73.5A4.063,4.063,0,0,0,89-75.579H86.874A4.064,4.064,0,0,0,83.453-73.5l-2.137,3.432,1.05.653L84.5-72.847a2.856,2.856,0,0,1,2.37-1.5H89a2.858,2.858,0,0,1,2.371,1.5L93.5-69.416l1.05-.653Z",
    transform: "translate(-81.316 84.828)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.4da1a8eb7650a28f4d5082b5b8590fb0.svg";
export { ForwardRef as ReactComponent };